import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeeConditionSubmissionsIndexRequestType,
  ApiManagersEmployeeConditionSubmissionsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersEmployeeConditionSubmissionsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersEmployeeConditionSubmissionsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersEmployeeConditionSubmissionsIndexResponseType>(
      "/api/managers/employee_condition_submissions",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersEmployeeConditionSubmissionsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApiManagersEmployeeConditionSubmissionsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersEmployeeConditionSubmissionsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["apiManagersEmployeeConditionSubmissionsIndex", params],
    ({ pageParam }) => {
      return request({
        params,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
